import type { DamageType } from '@/common/damage';
import { axios } from '@/lib/utils/axios';
import { getResponse } from '../common';
import { API_URLS } from '../query.client';
import { toApiPayload } from './damage-mapper';

export type UpdateDamageSuccessResponseType = DamageType;

export async function updateDamage(
	damageId: string,
	payload: Omit<DamageType, 'id'>
): Promise<UpdateDamageSuccessResponseType | null> {
	// Transform UI data to API structure (No inspectionId needed in body for Patch)
	const apiPayload = toApiPayload(payload);

	const response = await axios.patch(`${API_URLS.DAMAGES.INDEX}/${damageId}`, apiPayload);

	return getResponse<UpdateDamageSuccessResponseType>(response.data);
}
